import {
  invalidateSearchQueries,
  isCanonicalSearchQuery,
} from "@/lib/data/react-query/search/invalidation";
import { queryKeys } from "@/lib/data/static/query-keys";
import { useQueryClient } from "@tanstack/react-query";

export const useContactInvalidation = () => {
  const queryClient = useQueryClient();

  const invalidateContact = async () => {
    await invalidateSearchQueries(queryClient);
    await queryClient.invalidateQueries({
      predicate: (query) => !isCanonicalSearchQuery(query),
      queryKey: [queryKeys.contact],
    });
    await queryClient.invalidateQueries({
      predicate: (query) => !isCanonicalSearchQuery(query),
      queryKey: [queryKeys.contact, "search"],
    });
    // This is needed because if we are editing a contact connection,
    // the matter info can get updated via an event
    setTimeout(() => {
      void queryClient.invalidateQueries({
        predicate: (query) => !isCanonicalSearchQuery(query),
        queryKey: [queryKeys.matters],
      });
      void queryClient.invalidateQueries({
        predicate: (query) => !isCanonicalSearchQuery(query),
        queryKey: [queryKeys.matterSummary],
      });
    }, 500);
  };
  return invalidateContact;
};
